import styled from 'styled-components';

export const IconWrapper = styled.div`
  display: flex;
  justify-content: center;
  column-gap: 0.5rem;
  cursor: pointer;

  & svg {
    margin-top: 0.2rem;
    width: 1.1rem;
    height: 1.1rem;
  }
`;

export const Link = styled.a`
  font-family: 'Work Sans';
  font-style: normal;
  font-weight: 600;
  font-size: 1rem;
  text-decoration-line: underline;
  color: ${(p) => p.theme.colors.blue6};
`;
